module.exports = __webpack_public_path__ + "static/media/Nashville_Predators.824c8f38.svg";